import React, { useState, useRef } from 'react';
import './styles/Audio.css';
import audioProfessional from './assets/audio/professional.mp3';
import audioCasual from './assets/audio/unedit.mp3';

function Audio() {
  const [isProfessional, setIsProfessional] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const handleToggle = () => {
    setIsProfessional(!isProfessional);
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  };

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="audio-control">
      {/* Play/Pause Button */}
      <button className="play-button-description" onClick={handlePlayPause}>
        {isPlaying ? '❚❚' : '▶'}
      </button>

      {/* Toggle Switch */}
      <div className="toggle-switch">
        <label className="switch">
          <input type="checkbox" checked={isProfessional} onChange={handleToggle} />
          <span className="slider" />
        </label>
        {/* Dynamic label text */}
        <span className="toggle-label">
          {isProfessional ? 'Edited' : 'Unedited '}
        </span>
      </div>
      
      {/* Audio Element */}
      <audio
        ref={audioRef}
        src={isProfessional ? audioProfessional : audioCasual}
      />
    </div>
  );
}

export default Audio;
